const INTERPRETER_GROUP = 'interpreters';

export const isInterpreterUser = (userData) => {
  if (userData == null) {
    return false;
  }

  const { groups } = userData;

  return (groups || []).map((group) => group.toLowerCase()).includes(INTERPRETER_GROUP);
};

export const isChatAdmin = (userData) => {
  if (userData == null) {
    return false;
  }

  const { groups } = userData;

  return (groups || []).map((group) => group.toLowerCase()).includes(INTERPRETER_GROUP);
};
